<!--商品列表样式(大图)-->
<template>
	<div class="city-goods">
		<img class="city-goods-img" src="../assets/newImg/pic-index-banner.png" alt="">
		<div class="city-goods-name">小厨娘8人套餐只要99元</div>
		<div class="city-detail">
			<div class="city-detail-left">
				<div class="city-goods-price">
					<span>¥</span>19.9
				</div>
				<div class="city-goods-tprice">
					¥348
				</div>
				<div class="city-goods-earn">预估收益￥28.00</div>
			</div>
			<div class="city-goods-sell"> 已售 32</div>
		</div>
		<div class="city-goods-tip">
			<GoodsTips></GoodsTips>
		</div>
	</div>
</template>
<style scope>
	.city-goods {
		padding: 0 0.2rem;
	}
	
	.city-goods-img {
		width: 100%;
		height: 3.06rem;
	}
	
	.city-goods-name {
		color: #333333;
		font-size: 14px;
		font-weight: 500;
		padding: 0.2rem 0;
	}
	
	.city-detail {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 0.2rem;
		border-bottom: 1px solid #E5E5E5;
	}
	
	.city-detail-left {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	
	.city-goods-price {
		font-size: 17px;
		color: #FD2840;
		font-weight: 500;
	}
	
	.city-goods-price span {
		font-size: 12px;
	}
	
	.city-goods-tprice {
		color: #999999;
		text-decoration: line-through;
		margin: 0 0.1rem;
	}
	
	.city-goods-earn {
		font-size: 9px;
		color: #FD2840;
		background: rgba(253, 232, 234, 1);
		border-radius: 2px;
		border: 1px solid rgba(253, 40, 64, 1);
		height: 0.26rem;
		line-height: 0.26rem;
		padding: 0 0.05rem;
	}
	
	.city-goods-sell {
		color: #999999;
	}
	.city-goods-tip {
		padding: 0.2rem 0 0.3rem 0;
	}
	
</style>

<script>
	import GoodsTips from '@/components/GoodsTips.vue';
export default {
  name: 'GoodsItem3',
  props: [ ],
	components: {
		GoodsTips
	},
  data() {
    return {
    }
  },
  mounted:function () {
  },
  methods:{
  }
}
</script>



// WEBPACK FOOTER //
// GoodsItem3.vue?5b0a39ca